import { render, staticRenderFns } from "./IconSpinPlusQuiz.vue?vue&type=template&id=cfec2d8c&"
import script from "./IconSpinPlusQuiz.vue?vue&type=script&lang=js&"
export * from "./IconSpinPlusQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports